import React from 'react';
import { useApolloClient } from "@apollo/react-hooks";

import { GET_ME } from "graphql/query/user-gql";


import { HomeTimelinePosts, NewsTimelinePosts } from "components/posts";
import { UserAvatar } from "components/user";
import SummaryStatistic from "components/summary-statistic";
import { NotificationButton } from "components/notifications";
import { ContainerWrap, TimelineWrap, WrapColumn }  from "components/wraps";
import { ElementVisibility } from "components/service";


import logo from 'assets/mobile_logo.svg';



const HomePage = ({ type }) => {

    const client = useApolloClient();
    const { me } = client.readQuery({query: GET_ME});

    return (
        <>
            <ElementVisibility maxWidth={ 768 } type="show" comparison="<">
                <ul className="mobile-logo-wrap site-bg-color-second">
                    <li>
                        <img src={logo} alt="logo"/>
                    </li>
                    <li>
                        <NotificationButton
                            cssClass={ 'header-action-notification' }
                            userId={ me.id }
                        />
                    </li>
                </ul>
            </ElementVisibility>
            <div className="statistics-wrap site-bg-color-second">
                <ContainerWrap>
                    <SummaryStatistic />
                </ContainerWrap>
            </div>
            <ContainerWrap className="home-timeline-wrap container-margin">
                <TimelineWrap>
                    <WrapColumn position="left">
                        { type === "news" ?
                            <NewsTimelinePosts />:
                            <HomeTimelinePosts />
                        }

                    </WrapColumn>
                    <WrapColumn position="right">
                        <UserAvatar user={ {...me} }/>
                    </WrapColumn>
                </TimelineWrap>
            </ContainerWrap>
        </>
    );
};

export default HomePage;